import React, { useState } from 'react';
import {
	Grid,
	Box,
	Button,
	Container,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
	setSelectedArrival,
	setSelectedDepart,
	setTab,
} from '../../reducers/UiReducer';
import SearchEngneBus from './SearchEngneBus';
import { AutoComplete } from 'antd';
import SearchEngineHotel from './SearchEngineHotel';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
} from '../../reducers/HomeReducer';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import { AddSearchFlightFDDispatch } from '../../reducers/FDReducer';
import SearchEngineHolidays from './SearchEngineHolidays';
const Option = AutoComplete.Option;
const { RangePicker } = DatePicker;

const InternalSlideCard = ({ img, title, title2 }) => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const [options, setOptions] = useState([]);
	const [departDate, setDepartDate] = useState('');
	const [departDateReturn, setDepartDateReturn] = useState('');
	const [open, setOpen] = useState(false);
	const navigate = useNavigate();
	const { depart, arrival, tab, topTab } = useSelector((state) => state.ui);
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [loading, setLoading] = useState(false);
	const [infant, setInfant] = useState(0);
	const { city } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedDepart(value));
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleChange2 = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedArrival(value));
	};
	const handleSearch = () => {
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[0],
				},
				{
					Origin: arrival.split(' ')[0],
					Destination: depart.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[1],
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		if (tab === 'oneway') {
			navigate('/searchresult', { state: formData });
			dispatch(AddSearchFlightDispatch(formData, navigate));
		} else {
			navigate(
				depart?.split(',')[1] === 'IN' && arrival?.split(',')[1] === 'IN'
					? '/searchresultroundtrip'
					: '/searchresultinternational',
				{ state: formData2 }
			);
			dispatch(AddSearchFlightDispatch(formData2, navigate));
		}
	};
	const handleSubmit = () => {
		let formAIQ = {
			Origin: depart.split(' ')[0],
			Destination: arrival.split(' ')[0],
			DepartureDate: `${departDate.split('-')[0]}/${departDate.split('-')[1]}/${
				departDate.split('-')[2]
			}`,
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			AirlineCode: '',
			agent_id: 0,
		};
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		navigate('/searchresultpromo', { state: formData });
		dispatch(AddSearchFlightFDDispatch(formData, formAIQ));
	};
	const opsList2 =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}
					onChange={() =>
						console.log('a', l)
					}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const onChangeReturn: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDateReturn(dateString);
	};
	return (
		<Grid container>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				style={{
					height: matches ? '28vh' : '60vh',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: 'yellow',
					backgroundImage: `url(${img})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
					borderRadius: 10,
				}}></Grid>
		</Grid>
	);
};
export default InternalSlideCard;
